module.exports = __webpack_public_path__ + "img/cloud-showers-heavy.4ce780af.svg";